
import pagesNiv3et4Codes from "@/utils/pages-niv3&4-codes";

export const productListHeaderAppliedFiltersProps = () => ({
  appliedFilters: {
    type: Array,
    required: true
  },
  keyCode: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const useProductListHeaderAppliedFilters = () => {
  const getLabel = (filterLabel, parentFilterLabel) => {
    if (filterLabel === '1') {
      return parentFilterLabel
    } else {
      return filterLabel
    }
  }

  return { getLabel, pagesNiv3et4Codes }
}